<template>
  <div>KN GUARDIAN PAYMENTS</div>
</template>

<script>
const EXPIRATION_SECONDS = 16117;

export default {
  name: "kn-guardian-middleware",
  mounted() {
    const token = this.getCookie("deptoken");
    this.$store.dispatch("User/setToken", {
      token,
      expiresIn: EXPIRATION_SECONDS,
    });
    this.$store.dispatch("User/loadUser");
    this.$router.replace({ path: "/infoUsers/payment" });
  },
  methods: {
    getCookie(name) {
      const cookies = document.cookie.split("; ");
      for (let cookie of cookies) {
        let [cookieName, cookieValue] = cookie.split("=");
        if (cookieName === name) {
          return decodeURIComponent(cookieValue);
        }
      }
      return null;
    },
  },
};
</script>